import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import CsInquiryDetailContainer from '../../../containers/cs/inquiry/CsInquiryDetailContainer';
import { CS_INQUIRY_PAGE_NAME } from '../../../constants/service/app/csInquiryConstants';

const CsInquiryDetail = () => {
  return (
    <PageTemplate pageName={CS_INQUIRY_PAGE_NAME.INQUIRY_DETAIL}>
      <CsInquiryDetailContainer />
    </PageTemplate>
  );
};

export default CsInquiryDetail;
